// @flow

import {createSelector} from 'reselect';
import find from 'lodash/find';
import type {TeamMembershipType, TeamType, TeamViaType} from 'app/teams/types';

export const documentTeamVia = createSelector<
  Array<TeamMembershipType>,
  TeamType,
  TeamViaType,
  Array<TeamMembershipType>,
  string
>(
  (memberships) => memberships,
  (memberships, team) => team.url,
  (memberships, teamURL) => {
    const membership = find(memberships, {team: teamURL});
    return {
      via:
        membership == null
          ? null
          : membership.via_process
          ? 'process'
          : membership.via_folder
          ? 'folder'
          : null,
      name: membership == null ? '' : membership.via_name,
    };
  }
);

export const isMemberTeam = createSelector<
  Array<TeamMembershipType>,
  TeamType,
  TeamMembershipType | null,
  Array<TeamMembershipType>,
  string
>(
  (memberships) => memberships,
  (memberships, team) => team.url,
  (memberships, teamURL) => {
    const membership = find(memberships, {team: teamURL});
    return membership != null ? membership : null;
  }
);
